import {ActionType, createAction} from "typesafe-actions";
import {Chip, ReportItem} from "../store.types";
import {SearchParametersModel} from "../reducers/search";
import {Omit} from "@martin_hotell/rex-tils";
import {WorkPackage} from "../../models/responses/work-package.model";
import {FunctionModel} from "../../models/responses/function.model";

export const SearchActions = {
    setSearchValue: createAction('[Search] Set Search Value')<string>(),
    setTaskforceFilter: createAction('[Search] Set TaskForce Filter')<[string, string][]>(),
    setTaskOwnerFilter: createAction('[Search] Set Task Owner Filter')<any[]>(),
    removeIdFromTaskforecFilter: createAction('[Search] Remove Id From TaskForce Filter')<(string | null)[]>(),
    removeTaskOwnerFilter: createAction('[Search] Remove Task Owner Filter')<string | null>(),
    toggleAlert: createAction('[Search] Toogle Alert')(),
    setReportList: createAction('[Search] Set Report List')<ReportItem[]>(),
    addChip: createAction('[Search] Add Chip')<Chip[]>(),
    removeChip: createAction('[Search] Remove Chip')<string>(),
    removeAllChip: createAction('[Search] Remove All Chip')(),
    setReport: createAction('[Search] Set Report')<Omit<SearchParametersModel, 'searchText'>>(),
    setMapSearchText: createAction('[Search] Set Map Search Text')<string>(),
    setStartDate: createAction('[Search] Set Start Date')<number | null>(),
    setFinishDate: createAction('[Search] Set Finish Date')<number | null>(),
    resetAllFilters: createAction('[Search] Reset All Filters')(),
    setIncludeMilestones: createAction('[Search] Set Include Milestones')<boolean>(),
    setNoTaskForceFilter: createAction('[Search] Set No TaskForce Filter')<boolean>(),
    setSearchBarLoading: createAction('[Search] Set Search Bar Loading')<boolean>(),
    setWorkPackage: createAction('[Search] Set Work Package')<WorkPackage | null>(),
    setFunctionSearch: createAction('[Search] Set Function Search')<FunctionModel | null>(),
};

export type Actions = ActionType<typeof SearchActions>;
